module.exports = __webpack_public_path__ + "static/background-ca1e5aa73f6f7a88c9447a7833c28df7.png";